import { ThemeToggle } from "@/components/ui/themeToggle";
import { UserUi } from "@/entities/User";
import { RoutesConfig } from "@/shared/lib/model/routes";
import Link from "next/link";
export default function Header() {
	return (
		<header className="z-[1] sticky top-0 shrink-0 flex h-16 items-center gap-4 bg-background-grey rounded-3xl px-4 md:px-6">
			<nav className="text-sm font-medium flex items-center gap-5">
				<Link
					href={RoutesConfig.home.path}
					className="flex items-center gap-2 text-lg font-semibold md:text-base"
				>
					<div className="size-6 rounded-full bg-accent-foreground" />
					<span className="sr-only">Acme Inc</span>
				</Link>
				<Link
					prefetch={false}
					href={RoutesConfig.chat.path}
					className="text-foreground shrink-0 transition-colors hover:text-foreground"
				>
					Chat
				</Link>
			</nav>
			{/*<Sheet>
				<SheetTrigger asChild>
					<Button variant="outline" size="icon" className="shrink-0 md:hidden">
						<Menu className="h-5 w-5" />
						<span className="sr-only">Toggle navigation menu</span>
					</Button>
				</SheetTrigger>
				<SheetContent side="left">
					<nav className="grid gap-6 text-lg font-medium">
						<Link href={RoutesConfig.chat.path} className="hover:text-foreground">
							Chat
						</Link>
					</nav>
				</SheetContent>
			</Sheet>*/}
			<div className="flex w-full justify-end items-center gap-2 ">
				{/*<form className="ml-auto flex-1 sm:flex-initial">
					<div className="relative">
						<Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
						<Input
							type="search"
							placeholder="Search products..."
							className="pl-8 sm:w-[300px] md:w-[200px] lg:w-[300px]"
						/>
					</div>
				</form>*/}
				<UserUi.HeaderButtons />
				<ThemeToggle />
			</div>
		</header>
	);
}
